const activeLabelStyles = {
    transform: 'scale(0.85) translateY(-28px)'
}

export default {
    variants: {
        floating: {
            container: {
                _focusWithin: {
                    input: {
                        boxShadow: 'none',
                        borderColor: 'gray.550'
                    },
                    label: {
                        ...activeLabelStyles
                    }
                },
                'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label':
                    {
                        ...activeLabelStyles
                    },
                input: {
                    borderRadius: '5px',
                    borderColor: 'gray.550',
                    fontSize: '16px',
                    fontWeight: '400',
                    letterSpacing: '0.5px',
                    height: '50px',
                    paddingX: '20px',
                    color: 'black',
                    _hover: {
                        borderColor: 'gray.550'
                    }
                },
                label: {
                    top: '7px',
                    left: 0,
                    zIndex: 2,
                    position: 'absolute',
                    pointerEvents: 'none',
                    backgroundColor: 'white',
                    mx: 4,
                    px: 1,
                    my: 2,
                    transformOrigin: 'left top',
                    color: 'black',
                    fontSize: '14px',
                    fontWeight: '300',
                    letterSpacing: '0.5px'
                }
            }
        }
    }
}
